/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag React.Fragment
 */
import React from 'react';

import { useIntl } from 'react-intl';

import { jsx } from '@atlaskit/css';
import { ErrorMessage, Field, MessageWrapper } from '@atlaskit/form';
import Textfield from '@atlaskit/textfield';

import messages from '../../messages';

type Props = {
	value: string;
	onChange: (value: string) => void;
};

export const MAX_ASK_NAME_LENGTH = 255;

export const NameField = ({ value, onChange }: Props): JSX.Element => {
	const { formatMessage } = useIntl();
	const isMissing = !value.trim();
	const isTooLong = value.length > MAX_ASK_NAME_LENGTH;
	return (
		<Field name="name" label={formatMessage(messages.nameFieldLabel)} isRequired>
			{({ fieldProps }) => (
				<>
					<Textfield
						{...fieldProps}
						value={value}
						onChange={(e) => onChange((e.target as HTMLInputElement).value)}
						testId="focus-ask-name-field"
						maxLength={MAX_ASK_NAME_LENGTH}
						isInvalid={isMissing || isTooLong}
					/>
					<MessageWrapper>
						{isMissing && <ErrorMessage>{formatMessage(messages.bulkMissingInfo)}</ErrorMessage>}
						{!isMissing && isTooLong && (
							<ErrorMessage>
								{formatMessage(messages.nameFieldTooLong, { maxLength: MAX_ASK_NAME_LENGTH })}
							</ErrorMessage>
						)}
					</MessageWrapper>
				</>
			)}
		</Field>
	);
};
